import React from "react";
import { CloudPlatformProps } from "../../../../../components/cloud-platform/types";
import QuizBuilderImg from "/src/images/pages/ru-index/cloud-platform/ru-1.svg";
import QuizBuilderImgEn from "/src/images/pages/ru-index/cloud-platform/en-1.svg";
import VariusQuestionTypesImg from "/src/images/pages/ru-index/cloud-platform/ru-2.svg";
import VariusQuestionTypesImgEn from "/src/images/pages/ru-index/cloud-platform/en-2.svg";
import ThreePlayersModes from "/src/images/pages/ru-index/cloud-platform/ru-3.svg";
import ThreePlayersModesEn from "/src/images/pages/ru-index/cloud-platform/en-3.svg";
import SupportUp100Img from "/src/images/pages/ru-index/cloud-platform/en-4.svg";
import {getCurrentLang, Translate} from "../../../../../locales/locales-utils";

export const cloudPlatformProps = (): CloudPlatformProps => {
    const isRuLang = getCurrentLang() === "ru";

    return  {
        title: Translate("Index.Advantages.Title"),
        cards: [
            {
                title: Translate("Index.Advantages.Items.0.Title"),
                body: Translate("Index.Advantages.Items.0.Description"),
                img: (
                    <img src={isRuLang ? QuizBuilderImg : QuizBuilderImgEn} alt={Translate("Index.Advantages.Items.0.Title")} />
                ),
                position: "left"
            },
            {
                title: Translate("Index.Advantages.Items.1.Title"),
                body: Translate("Index.Advantages.Items.1.Description"),
                img: (
                    <img src={isRuLang ? VariusQuestionTypesImg : VariusQuestionTypesImgEn} alt={Translate("Index.Advantages.Items.1.Title")} />
                ),
                position: "right"
            },
            {
                title: Translate("Index.Advantages.Items.2.Title"),
                body: Translate("Index.Advantages.Items.2.Description"),
                img: (
                    <img src={isRuLang ? ThreePlayersModes : ThreePlayersModesEn} alt={Translate("Index.Advantages.Items.2.Title")} />
                ),
                position: "left"
            },
            {
                title: Translate("Index.Advantages.Items.3.Title"),
                body: Translate("Index.Advantages.Items.3.Description"),
                img: (
                    <img src={SupportUp100Img} alt={Translate("Index.Advantages.Items.3.Title")} />
                ),
                position: "right"
            },
        ],
        animationDisabled: true
    }
};

